var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.getAppliedDeliveryFee)?_c('h3',{staticClass:"text-body-1"},[_vm._v("Delivery Fee : $"+_vm._s(_vm.roundToFixed(_vm.getAppliedDeliveryFee / 100)))]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }